import styled from "styled-components";

export const ContactSection = styled.section`
  background-color: var(--color-grey-main);
  border-top: 1px solid rgba(141, 153, 174, 0.3);
  border-bottom: 1px solid rgba(141, 153, 174, 0.3);
`;
